import React from 'react'
import GlobalStorage from '../storage/GlobalStorage'
import {Container,Row,Col,Button} from 'reactstrap';

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
    this.GS = new GlobalStorage();
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render()
  {
    return (
      <div>
        <div>
          <Container className="pt-5">
            <Row className="pb-5">
              <Col className="text-center">                
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
              </Col>              
            </Row>
            <Row className="pb-5">
              <Col className="text-center">                
                  <p className="text-white">Welcome to your TBC workplace!</p>
                  <Button onClick={()=>{
                    console.log(this.GS.getUser());
                    if (this.GS.getUser().token===null){
                      this.props.toggleModalState('login');
                      this.props.toggleModal(true);            
                    }else{
                      this.props.switchMain('StoryList');
                      this.props.switchMenu('StoryList');            
                    }        
                  }}>馬上創立你的故事!</Button>                
              </Col>              
            </Row>
          </Container>
        </div>
        <div className="bg-light" style={{minHeight:`35px`} }>
          <Container>
            <Row className="pt-5 pb-5">
                <Col md="4" className="p-5">     
                  <h3>Step 1: </h3>           
                  <h2>使用Word 編輯，</h2>
                  <h2>儲存文字初稿</h2>
                </Col>              
                <Col md="8">
                  <div class="embed-responsive embed-responsive-16by9">
                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/Q7VwBIN7cg8?rel=0" allowfullscreen></iframe>
                  </div>
                </Col>
            </Row>
            <Row className="pt-5 pb-5">
                <Col md="8">
                  <div class="embed-responsive embed-responsive-16by9">
                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/31j1jnniJgY?rel=0" allowfullscreen></iframe>
                  </div>
                </Col>
                <Col md="4" className="p-5">                
                  <h3>Step 2: </h3>           
                  <h2>進入編輯器</h2>
                </Col>                              
            </Row>
            <Row className="pt-5 pb-5">
                <Col md="4" className="p-5">                
                  <h3>Step 3: </h3>           
                  <h2>整理你的故事</h2>
                </Col>              
                <Col md="8">
                  <div class="embed-responsive embed-responsive-16by9">
                    <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/jZTm2E7xsGA?rel=0" allowfullscreen></iframe>
                  </div>
                </Col>
            </Row>            
          </Container>

        </div>
      </div>
    )
  }
}